import axios from "axios";

const GETDATARDV_API_BASE_URL = "https://doclicapp.herokuapp.com/api/rdv/admin";
const DELETERDV_API_BASE_URL = "https://doclicapp.herokuapp.com/api/rdv";
class ServiceSearchRdv {
  // getdatardv() {
  //   return axios.get(GETDATARDV_API_BASE_URL);
  // }
  getRdvByAdmin(id) {
    return axios.get(GETDATARDV_API_BASE_URL + "/" + id);
  }
  deleterdv(id) {
    return axios.delete(DELETERDV_API_BASE_URL + "/" + id);
  }
}

export default new ServiceSearchRdv();
